/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddProductionOrderWasteAssignmentToOuterEntry } from '../../models/add-production-order-waste-assignment-to-outer-entry';

export interface AddProductionOrderWasteAssignmentToOuter$Params {
  productionOrderId: number;
      body: AddProductionOrderWasteAssignmentToOuterEntry
}

export function addProductionOrderWasteAssignmentToOuter(http: HttpClient, rootUrl: string, params: AddProductionOrderWasteAssignmentToOuter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addProductionOrderWasteAssignmentToOuter.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addProductionOrderWasteAssignmentToOuter.PATH = '/api/v1/ProductionOrder/{productionOrderId}/Outer/AddWasteAssignmentToOuter';
